export default "__VITE_ASSET__c176dc9b__"